import { get } from 'lodash';
import { connect } from 'react-redux';
import { lifecycle, compose, withProps } from 'recompose';

import { omitProps } from '../../../../common/helpers/props';
import { getPoVendors, isLoadingVendors } from '../store/selectors';
import { fetchVendors } from '../store/actions';
import { getBrandId, getShopBrandId, isBrandViewActive } from '../../../../auth/selectors';
import { canUserModifyProducts } from '../../../../common/helpers/users';

const poVendorsProvider = (config = {}) => compose(
  connect(
    state => ({
      canEditProducts: canUserModifyProducts(state.auth.permissions),
      vendors: getPoVendors(state),
      isLoadingVendors: isLoadingVendors(state),
      brandId: isBrandViewActive(state) ? getBrandId(state) : getShopBrandId(state),
    }), {
      fetchVendors,
    }
  ),
  lifecycle({
    async componentDidMount() {
      this.props.fetchVendors(this.props.brandId);
    },
  }),
  withProps((props) => {
    const filteredVendors = get(config, 'onlyEnabled') === true
      ? props.vendors.filter(vendor => vendor.enabled)
      : props.vendors;

    return {
      vendors: filteredVendors,
    };
  }),
  omitProps(['fetchVendors', 'brandId']),
);

export default poVendorsProvider;
